import { RazorButton } from "../../razor-reuse";
import React from "react";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import "./TitleBtnFragment.css";

interface myComponentProps {
  title?: string;
  loadingText?: string;
  btnLabel?: string;
  loading?: boolean;
  disable?: boolean;
  hideBtn?: boolean;
  sticky?: boolean;
  onBtnClick?: () => void;
  className?: string;
  hideicon?: boolean;
  icon?: any;
  selectFragment?: any;
  text?: string;
}

const TitleBtnFragment = ({
  btnLabel,
  className,
  disable,
  loading,
  onBtnClick,
  hideBtn,
  title,
  sticky,
  hideicon,
  icon,
  loadingText,
  text,
  selectFragment,
}: myComponentProps) => {
  return (
    <div
      className={`title-btn-reuse-general-wrapper-index ${
        sticky ? "title-btn-reuse-general-wrapper-index-sticky" : ""
      } ${className || ""}`}
    >
      <div className="title-select">
        <div className="title-text-box">
          {title && (
            <div className="title">
              {title || ""} {selectFragment ? selectFragment : ""}
            </div>
          )}
          {text && <p className="text">{text}</p>}
        </div>
      </div>

      {/* btn box start */}
      {!hideBtn && (
        <div className="btn-setting-box-wrap">
          <RazorButton
            onClick={() => {
              onBtnClick && onBtnClick();
            }}
            loading={loading}
            color="black-light"
            className="btn"
            disabled={disable}
            // loaderText={loadingText ? loadingText : ''}
          >
            {!hideicon && (
              <figure className="img-box">{icon || ALL_ICONS?.plus}</figure>
            )}
            <p className="text">{btnLabel}</p>
          </RazorButton>
        </div>
      )}
      {/* btn box end */}
    </div>
  );
};

export default TitleBtnFragment;
